"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
require("./index.css");
const FilterTabBar = (props) => {
    const { title, tabs } = props;
    const _renderCount = (count, active) => {
        return (React.createElement("sup", { className: `filter_tab_bar__tab_count${active ? "" : " filter_tab_bar__tab_count__inactive"}` }, count));
    };
    const _renderTab = (tab) => {
        const { title, onClick, count, active } = tab;
        return (React.createElement("div", { className: "filter_tab_bar__tab_row", key: title, onClick: () => onClick(tab.title) },
            React.createElement("a", { className: `filter_tab_bar__tab${active ? "__active" : ""}` },
                title,
                count && _renderCount(count, active))));
    };
    const _renderTabRows = () => {
        return (React.createElement("div", { className: "filter_tab_bar__tab_row_container" },
            React.createElement("div", { className: "filter_tab_bar__tab_row_label" }, "Filter By"),
            tabs.map(tab => {
                return _renderTab(tab);
            })));
    };
    return (React.createElement("div", { className: "filter_tab_bar" },
        React.createElement("div", { className: "filter_tab_bar__header" }, title),
        _renderTabRows()));
};
exports.default = FilterTabBar;
//# sourceMappingURL=FilterTabBar.js.map